import React from "react";

/* ─────────────────────────────────────────
   Données légales de l'entreprise
   ───────────────────────────────────────── */
const ML = {
  dateMAJ:   "16 juin 2026",
  entreprise: {
    nom:              "SlimeTech",
    forme:            "Entreprise individuelle",
    siren:            "106 318 041",
    dateImmat:        "15 juin 2026",
    registre:         "Registre National des Entreprises (RNE)",
  },
  dirigeant: {
    nom:   "Anthony RODRIGUEZ",
    email: "slime-tech@outlook.fr",
  },
  hebergeur: {
    nom:    "OVH SAS",
    adresse:"2 rue Kellermann, 59100 Roubaix, France",
    site:   "www.ovhcloud.com",
  },
};

/* ─────────────────────────────────────────
   Sous-composant Article
   ───────────────────────────────────────── */
const Article = ({ number, title, children }) => (
  <article className="ml-article">
    <div className="ml-article-header">
      <span className="ml-article-num">{number}</span>
      <h2 className="ml-article-title">{title}</h2>
    </div>
    <div className="ml-article-body">{children}</div>
  </article>
);

const MentionsLegales = () => (
  <main className="ml-page">

    {/* ── Bannière ── */}
    <div className="ml-banner">
      <div className="p-container ml-banner-inner">
        <a href="/" className="ml-back">
          <i className="bi bi-arrow-left" /> Retour au site
        </a>
        <div className="ml-banner-badge">
          <i className="bi bi-shield-check" /> Légal
        </div>
        <h1 className="ml-banner-title">Mentions légales</h1>
        <p className="ml-banner-date">
          Dernière mise à jour : {ML.dateMAJ}
        </p>
      </div>
    </div>

    {/* ── Intro ── */}
    <div className="ml-intro-wrap">
      <div className="p-container">
        <p className="ml-intro">
          Conformément aux dispositions de la loi n°2004-575 du 21 juin 2004 pour la confiance dans
          l'économie numérique, il est précisé aux utilisateurs du site les informations suivantes.
        </p>
      </div>
    </div>

    {/* ── Articles ── */}
    <div className="p-container ml-content">

      <Article number="1" title="Éditeur du site">
        <p>Le présent site est édité par :</p>
        <div className="ml-info-block">
          <div className="ml-info-row">
            <i className="bi bi-building" />
            <strong>{ML.entreprise.nom}</strong>
          </div>
          <div className="ml-info-row">
            <i className="bi bi-briefcase" />
            <span>{ML.entreprise.forme}</span>
          </div>
          <div className="ml-info-row">
            <i className="bi bi-upc-scan" />
            <span>SIREN : <strong>{ML.entreprise.siren}</strong></span>
          </div>
          <div className="ml-info-row">
            <i className="bi bi-calendar-check" />
            <span>
              Immatriculée au {ML.entreprise.registre} le{" "}
              <strong>{ML.entreprise.dateImmat}</strong>
            </span>
          </div>
          <div className="ml-info-row">
            <i className="bi bi-person-fill" />
            <span>Représentant légal : <strong>{ML.dirigeant.nom}</strong></span>
          </div>
          <div className="ml-info-row">
            <i className="bi bi-envelope-fill" />
            <a href={`mailto:${ML.dirigeant.email}`}>{ML.dirigeant.email}</a>
          </div>
        </div>
        <p>
          Ce site a pour objectif de présenter les services proposés par {ML.entreprise.nom},
          notamment la création de sites vitrines, d'applications web et des conseils techniques.
        </p>
      </Article>

      <Article number="2" title="Responsable de la publication">
        <p>Le responsable de la publication est :</p>
        <div className="ml-info-block">
          <div className="ml-info-row">
            <i className="bi bi-person-fill" />
            <strong>{ML.dirigeant.nom}</strong>
          </div>
          <div className="ml-info-row">
            <i className="bi bi-building" />
            <span>Gérant de {ML.entreprise.nom}</span>
          </div>
          <div className="ml-info-row">
            <i className="bi bi-envelope-fill" />
            <a href={`mailto:${ML.dirigeant.email}`}>{ML.dirigeant.email}</a>
          </div>
        </div>
      </Article>

      <Article number="3" title="Hébergement du site">
        <p>Le site est hébergé par :</p>
        {/* ⬇️ MODIFIABLE — Remplir dans l'objet ML.hebergeur en haut de fichier */}
        <div className="ml-info-block">
          <div className="ml-info-row">
            <i className="bi bi-building" />
            <strong>{ML.hebergeur.nom}</strong>
          </div>
          <div className="ml-info-row">
            <i className="bi bi-geo-alt-fill" />
            <span>{ML.hebergeur.adresse}</span>
          </div>
          <div className="ml-info-row">
            <i className="bi bi-globe" />
            <a href={`https://${ML.hebergeur.site}`} target="_blank" rel="noopener noreferrer">
              {ML.hebergeur.site}
            </a>
          </div>
        </div>
      </Article>

      <Article number="4" title="Propriété intellectuelle">
        <p>
          L'ensemble des éléments présents sur ce site, notamment les textes, images, illustrations,
          icônes, éléments graphiques, logo, structure, mise en page et code source, sont protégés
          par le droit de la propriété intellectuelle.
        </p>
        <p>
          Sauf mention contraire, ces éléments sont la propriété de {ML.entreprise.nom} ou sont
          utilisés avec autorisation.
        </p>
        <div className="ml-highlight">
          <i className="bi bi-exclamation-circle-fill" />
          <span>
            Toute reproduction, représentation, modification, publication, adaptation ou exploitation
            de tout ou partie du site, par quelque moyen que ce soit, est <strong>interdite</strong> sans
            autorisation écrite préalable de {ML.entreprise.nom}.
          </span>
        </div>
      </Article>

      <Article number="5" title="Données personnelles">
        <p>
          Le site propose un formulaire de contact permettant à l'utilisateur d'envoyer un message
          à {ML.entreprise.nom}.
        </p>
        <p>Les données collectées via ce formulaire peuvent inclure :</p>
        <ul className="ml-list">
          <li><i className="bi bi-dot" />le nom ;</li>
          <li><i className="bi bi-dot" />l'adresse email ;</li>
          <li><i className="bi bi-dot" />l'objet du message ;</li>
          <li><i className="bi bi-dot" />le contenu du message.</li>
        </ul>
        <p>
          Ces données sont utilisées <strong>uniquement</strong> pour répondre aux demandes envoyées
          via le formulaire de contact.
        </p>
        <p>
          Aucune donnée personnelle n'est vendue, cédée ou transmise à des tiers à des fins
          commerciales. Les données sont conservées uniquement pendant la durée nécessaire au
          traitement de la demande.
        </p>
        <div className="ml-highlight ml-highlight--info">
          <i className="bi bi-shield-check" />
          <span>
            Conformément au Règlement général sur la protection des données (RGPD) et à la loi
            Informatique et Libertés, vous disposez d'un droit d'accès, de rectification et de
            suppression de vos données personnelles. Pour exercer ces droits, contactez-nous à{" "}
            <a href={`mailto:${ML.dirigeant.email}`}>{ML.dirigeant.email}</a>.
          </span>
        </div>
      </Article>

      <Article number="6" title="Cookies">
        <p>
          Le site peut utiliser des cookies strictement nécessaires à son bon fonctionnement.
        </p>
        <p>
          Si des cookies de mesure d'audience, de publicité ou de services tiers sont ajoutés
          ultérieurement, une information claire sera affichée à l'utilisateur et son consentement
          sera demandé lorsque cela est nécessaire, conformément à la réglementation en vigueur.
        </p>
      </Article>

      <Article number="7" title="Liens externes">
        <p>Le site peut contenir des liens vers des sites externes.</p>
        <p>
          {ML.entreprise.nom} ne peut être tenu responsable du contenu, du fonctionnement ou de
          la politique de confidentialité de ces sites tiers.
        </p>
      </Article>

      <Article number="8" title="Responsabilité">
        <p>
          {ML.entreprise.nom} s'efforce de fournir des informations aussi exactes que possible.
          Toutefois, les informations présentes sur ce site sont fournies à titre indicatif et
          peuvent être modifiées à tout moment sans préavis.
        </p>
        <p>
          {ML.entreprise.nom} ne peut être tenu responsable des erreurs, omissions ou
          indisponibilités temporaires du site.
        </p>
      </Article>

      <Article number="9" title="Droit applicable">
        <p>Le présent site est soumis au droit français.</p>
        <p>
          En cas de litige, et à défaut de résolution amiable, les juridictions françaises
          compétentes seront saisies.
        </p>
      </Article>

      {/* Retour */}
      <div className="ml-footer-nav">
        <a href="/" className="btn-p btn-p--outline">
          <i className="bi bi-arrow-left" /> Retour au site
        </a>
      </div>

    </div>
  </main>
);

export default MentionsLegales;
